import { Navigate, useLocation } from 'react-router-dom';
import { isDemoMode } from '../../demo/demoState';

/**
 * NotFoundRedirect handles 404/unknown routes.
 * - Demo mode: redirect to /auth/login preserving full search string
 * - Otherwise: redirect to /auth/login
 */
export function NotFoundRedirect() {
  const location = useLocation();

  if (isDemoMode()) {
    return <Navigate to={`/auth/login${location.search}`} replace />;
  }

  return <Navigate to="/auth/login" replace />;
}
